import * as React from "react";
import { GenericDialog } from "../../generic-dialog/GenericDialog.component";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MessageService } from "../../../services/message.service";
import { trainingUserMistakeService } from "../../../../modules/training/services/TrainingUserMistakeService";
import { rankTrainingErrors } from "./trainingResultsRanking";
import { TrainingSpeedChart } from "./TrainingSpeedChart.component";
import "./EndTrainingDialog.component.css";
export function EndTrainingDialog() {
    const [isVisible, setIsVisible] = useState(false);
    const confirmFn = useRef(() => { });
    const restartFn = useRef(() => { });
    const revisitErrorsFn = useRef(() => { });
    const [trainingName, setTrainingName] = useState("");
    const [trainingResults, setTrainingResults] = useState(undefined);
    const showEndTrainingDialog = (trainingName, trainingResults, onConfirm, onCustom, onRevisitErrors) => {
        setTrainingName(trainingName);
        setTrainingResults(trainingResults);
        confirmFn.current = onConfirm;
        restartFn.current = onCustom;
        revisitErrorsFn.current = onRevisitErrors;
        setIsVisible(true);
    };
    useEffect(() => {
        MessageService.registerGlobalEndTrainingFn(showEndTrainingDialog);
    }, []);
    const confirm = () => {
        setIsVisible(false);
        confirmFn.current();
    };
    const restart = () => {
        setIsVisible(false);
        restartFn.current();
    };
    const revisitErrors = () => {
        setIsVisible(false);
        revisitErrorsFn.current();
    };
    const logValuesToConsole = (stats) => {
        console.log(JSON.stringify(stats));
    };
    const stageErrors = trainingUserMistakeService.getStageErrors();
    const movementViolations = trainingResults === undefined
        ? []
        : [...trainingResults.entries()].flatMap(([objectName, stats]) => stats.violations.map((violation, index) => ({ objectName, threshold: stats.threshold, violation, index })));
    const movementViolationsByStage = new Map();
    movementViolations.forEach((movementViolation) => {
        var _a;
        const stageViolations = (_a = movementViolationsByStage.get(movementViolation.violation.stage)) !== null && _a !== void 0 ? _a : [];
        stageViolations.push(movementViolation);
        movementViolationsByStage.set(movementViolation.violation.stage, stageViolations);
    });
    const totalErrors = stageErrors.length + movementViolations.length;
    const rank = trainingResults === undefined ? 0 : rankTrainingErrors(totalErrors);
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(GenericDialog, { title: "Training abgeschlossen", confirmText: "Neustarten", customText: "Schließen", custom2Text: "Fehler korrigieren", onConfirm: restart, onCustom: confirm, onCustom2: revisitErrors, hideCancel: true, hideCustom: false, hideCustom2: trainingUserMistakeService.getNumberOfNewSequencesWithMistakes() === 0, width: "medium" },
        React.createElement("div", { className: "end-training-content" },
            React.createElement("section", { className: "end-training-hero" },
                React.createElement("span", { className: "end-training-eyebrow" }, "PharmaXR Training"),
                React.createElement("h2", null, trainingName),
                React.createElement("div", { className: "end-training-rating", "aria-label": `Bewertung: ${rank} von 5 Sternen` }, "★".repeat(rank) + "☆".repeat(5 - rank)),
                React.createElement("span", { className: "end-training-rating-label" }, "Gesamtbewertung")),
            React.createElement("section", { className: "end-training-section" },
                React.createElement("h3", null, "Bewegungsauswertung"),
                !!trainingResults && trainingResults.size > 0 ? (React.createElement("div", { className: "end-training-stats-list" }, [...trainingResults.entries()].map(([key, stats]) => (React.createElement("article", { className: "end-training-stats-card", key: key },
                    React.createElement("div", { className: "end-training-stats-heading" },
                        React.createElement("h4", null, key),
                        React.createElement("a", { onClick: () => logValuesToConsole(stats) },
                            stats.count,
                            " Werte erfasst")),
                    React.createElement("div", { className: "end-training-stat-grid" },
                        React.createElement("div", null,
                            React.createElement("span", null, "Maximum"),
                            React.createElement("strong", null,
                                stats.max.toFixed(2),
                                " m/s")),
                        React.createElement("div", null,
                            React.createElement("span", null, "Mittelwert"),
                            React.createElement("strong", null,
                                stats.mean.toFixed(2),
                                " m/s")),
                        React.createElement("div", null,
                            React.createElement("span", null, "Median"),
                            React.createElement("strong", null,
                                stats.median.toFixed(2),
                                " m/s"))),
                    React.createElement("div", { className: "end-training-violations" },
                        "\u00DCberschreitungen (>",
                        stats.threshold,
                        " m/s)",
                        React.createElement("strong", { className: stats.violations.length > 0 ? "has-violations" : "" }, stats.violations.length)),
                    React.createElement("details", { className: "end-training-chart-details" },
                        React.createElement("summary", null, "Geschwindigkeitsverlauf"),
                        React.createElement(TrainingSpeedChart, { objectName: key, stats: stats }))))))) : (React.createElement("p", { className: "end-training-empty" }, "Keine Bewegungsdaten erfasst."))),
            React.createElement("section", { className: "end-training-section" },
                React.createElement("h3", null, "Fehler\u00FCbersicht"),
                React.createElement("div", { className: "end-training-sequences" },
                    React.createElement("span", null,
                        "Betroffene Sequenzen ",
                        React.createElement("strong", null, trainingUserMistakeService.getNumberOfNewSequencesWithMistakes())),
                    React.createElement("span", null, trainingUserMistakeService.getNewSequenceNamesWithOccurredErrors().join(", ") || "Keine")),
                React.createElement("div", { className: "end-training-errors" },
                    React.createElement("b", null,
                        "Erfasste Fehler ",
                        React.createElement("span", null,
                            "(",
                            totalErrors,
                            ")")),
                    totalErrors > 0 ? (React.createElement("ul", null,
                        stageErrors.map(({ stage, text, errorType }, index) => (React.createElement("li", { key: `${stage.id}-${index}` },
                            React.createElement("details", null,
                                React.createElement("summary", null,
                                    React.createElement("b", null,
                                        errorType,
                                        ":"),
                                    " ",
                                    stage.label),
                                React.createElement("div", { className: "end-training-error-detail" }, text || "Keine Fehlerbeschreibung"))))),
                        [...movementViolationsByStage.entries()].map(([stageId, violations]) => (React.createElement("li", { key: stageId !== null && stageId !== void 0 ? stageId : "unknown-stage" },
                            React.createElement("details", null,
                                React.createElement("summary", null,
                                    React.createElement("b", null, "Geschwindigkeits\u00FCberschreitungen:"),
                                    " ",
                                    trainingUserMistakeService.getStageLabel(stageId),
                                    " (",
                                    violations.length,
                                    ")"),
                                React.createElement("ul", null, violations.map(({ objectName, threshold, violation, index }) => (React.createElement("li", { key: `${objectName}-${violation.timestamp}-${index}` },
                                    React.createElement("div", { className: "end-training-error-detail" },
                                        React.createElement("div", null, objectName),
                                        React.createElement("div", null,
                                            "Geschwindigkeit: ",
                                            violation.speed.toFixed(2),
                                            " m/s (Grenzwert: ",
                                            threshold.toFixed(2),
                                            " m/s)"),
                                        React.createElement("div", null,
                                            "Dauer: ",
                                            (violation.durationMs / 1000).toFixed(2),
                                            " s")))))))))))) : (React.createElement("p", { className: "end-training-empty" }, "Keine Fehler erfasst.")))),
            React.createElement("div", { className: "end-training-prompt" },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "user-astronaut"] }),
                React.createElement("span", null, "M\u00F6chten Sie das Szenario neustarten oder Ihre Fehler korrigieren?")))))));
}
